import { render, staticRenderFns } from "./SidebarDatabases.vue?vue&type=template&id=5c064f5b&scoped=true&lang=pug&"
import script from "./SidebarDatabases.vue?vue&type=script&lang=ts&"
export * from "./SidebarDatabases.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarDatabases.vue?vue&type=style&index=0&id=5c064f5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c064f5b",
  null
  
)

export default component.exports